import React from "react";
import { Box, Toolbar, Typography } from "@mui/material";
import "./styles.scss";
import LoanSummaryTable from "../../../components/loanSummaryTable/LoanSummaryTable";

const LoanStatement = () => {

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="transactions-history-title">
          Loan Statement Summary
        </Typography>
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        <LoanSummaryTable />
      </Box>
    </>
  );
};

export default LoanStatement;
